/**
 * INIT
 * ----
 * This function initialize every element of the main header
 **/
export function init() {
  $('.footer__socials--open').on('click', function(e) {
    e.preventDefault()
    $('.footer__socials').toggleClass('open');
  })
}


// WEBPACK FOOTER //
// ./scripts/components/MainFooter.js